module.exports = __webpack_public_path__ + "assets/img/close.3949df43.svg";